import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    LabelList,
    Label,
    LineChart,
    Line,
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
} from 'recharts';
import { encryptStorage } from '../constant';
import { getAttritionByReason, getAttritionByTenure, getExitByGender, getInsiteByDomain } from '../service/api';
// import '../components/css/';

export default function AttritionDashboard({ filterObj }) {
    let propsobj = { filterObj };
    //state variables declaring
    const [insitebyDomain, setInsitebyDomain] = useState(); //PC_FD_03
    const [exitbyGender, setExitbyGender] = useState([]); //PC_FD_04
    const [byTenure, setByTenure] = useState([]); //PC_FD_05
    const [byReason, setByReason] = useState([]); //PC_FD_06
    const [Total, setTotal] = useState([]); //PC_FD_07
    const [Termination, setTermination] = useState(); //PC_FD_08
    const [Resignation, setResignation] = useState(); //PC_FD_09
    const [Abscond, setAbscond] = useState(); //PC_FD_10
    const [attritionforreason, setattritionforreason] = useState([]);

    const COLORS = ['#49BEF2','#DD6299'];
    // const formattedData = [];
    const [gender, setGender] = useState([]);
    const [domain, setDomain] = useState([]); //PC_FD_12
    const navigateTo = useNavigate(); //PC_FD_13 use navigate hook

    //PC_FD_14 calling functions
    useEffect(() => {
        //PC_FD_15
        if (encryptStorage.getItem('groupid') == 1) {
            InsiteByDomain();
            ExitByGender();
            AttritionByTenure();
            AttritionByReason();
        }
    }, [filterObj]);

    // rendering total count on page load
    // useEffect(() => {
    //     // Calculate counts when insiteByDomain changes
    //     // const total = insitebyDomain?.reduce((total, item) => total + item.resignation + item.termination + item.abscond, 0);

    //     const resignation = insitebyDomain?.reduce((total, item) => total + item.resignation, 0);
    //     const termination = insitebyDomain?.reduce((total, item) => total + item.termination, 0);
    //     const abscond = insitebyDomain?.reduce((total, item) => total + item.abscond, 0);

    //     setTotal(parseInt(resignation) + parseInt(termination) + parseInt(abscond));
    //     setResignation(parseInt(resignation));
    //     setTermination(parseInt(termination));
    //     setAbscond(parseInt(abscond));
    // }, []); // Calculate counts whenever insiteByDomain changes

    let totalResignationCount = 0;
    let totalabscond = 0;
    let totaltermination = 0;
    let total = 0;

    //PC_FD_16 function call
    const InsiteByDomain = async () => {
        let response = await getInsiteByDomain(filterObj); //PC_FD_17
        if (response.status == 200) {
            setInsitebyDomain(response.data);

            // Iterate over each object in the data array
            response.data.forEach((item) => {
                // Add the resignation count of the current object to the total count
                totalResignationCount += parseInt(item.resignation);
                totalabscond += parseInt(item.abscond);
                totaltermination += parseInt(item.termination);
                total = totalResignationCount + totalabscond + totaltermination;
            });
            setResignation(totalResignationCount);
            setAbscond(totalabscond);
            setTermination(totaltermination);
            setTotal(total);
        }
    };

    // //PC_FD_33 function call
    const ExitByGender = async () => {
        try {
            let response = await getExitByGender(filterObj);
            if (response.status === 200) {
                // Set the state with response data directly
                setExitbyGender(response.data);
                const maleValue = response.data[1] ? parseInt(response.data[1].male) : parseInt(response.data[0]?.male || 0);
                const femaleValue = response.data[2] ? parseInt(response.data[2].female) : parseInt(response.data[0]?.female || 0);
           
                const formattedData = [
                    { name: 'Male', value: maleValue },
                    { name: 'Female', value: femaleValue },
                ];
                // Set the formatted data to state
                setGender(formattedData);
            }
        } catch (error) {
            console.error('Error fetching exit by gender data:', error);
        }
    };

    //PC_FD_50 function call
    const AttritionByTenure = async () => {
        let response = await getAttritionByTenure(filterObj); //PC_FD_51
        if (response.data.status == 200) {
            setByTenure(response.data.result); //PC_FD_52
        }
    };

    //PC_FD_53 calculations
    // Define the tenure intervals
    const tenureIntervals = ['<6 Month', '1-2 Years', '2-3 Years', '3-4 Years', '>5 Years'];

    // Map each year of experience to the corresponding tenure interval
    const mappedData = byTenure?.map((dataPoint) => {
        let tenureInterval;
        const year = parseInt(dataPoint.tenure?.replace('Year ', ''));

        if (year < 1 / 2) {
            tenureInterval = '<6 Month';
        } else if (year >= 1 && year <= 2) {
            tenureInterval = '1-2 Years';
        } else if (year > 2 && year <= 3) {
            tenureInterval = '2-3 Years';
        } else if (year > 3 && year <= 4) {
            tenureInterval = '3-4 Years';
        } else {
            tenureInterval = '>5 Years';
        }
        return { tenureInterval, numberOfEmployees: dataPoint.exitCount };
    });

    // Aggregate employee count for each interval
    //PC_FD_53
    const aggregatedData = [];
    tenureIntervals.forEach((interval) => {
        const employeesInInterval = mappedData.filter((dataPoint) => dataPoint.tenureInterval === interval);
        const totalEmployees = employeesInInterval.reduce((total, dataPoint) => total + (dataPoint.numberOfEmployees || 0), 0);
    
        aggregatedData.push({ tenureInterval: interval, numberOfEmployees: totalEmployees });
    });

 

    const AttritionByReason = async () => {
        let response = await getAttritionByReason(filterObj); //PC_FD_68
        //setReasonType(response.data.reasons);
        setattritionforreason(response.data.attrition);
    };

    return (
        <>
            {/* <div className="tab-pane fade" id="pills-Attrition" role="tabpanel" aria-labelledby="Attrition-dashboard-tab">          */}
            <div className="row row-cols-1 g-3 py-3">
                <div className="col-md-12 col-sm-12">
                    <div className="card h-100 border-0 shadow-sm p-4">
                        <div className="row">
                            <div className="col-md-3 position-relative">
                                <div className="row  custom-border-end">
                                    <div className="d-flex ">
                                        <span>
                                            <img src="Images/totalexits-icon.svg" alt="totalexits-icon" className="dashboard-style-49" />
                                        </span>
                                        <div className="d-block">
                                            <h2 className="tt-bold ps-3 font-28 mb-0 dashboard-activities-count dashboard-activities-count">
                                                {Total}
                                            </h2>
                                            <a className="tt-bold ps-3  font-13 dashboard-link text-decoration-none">Total Exits</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 position-relative">
                                <div className="row  custom-border-end">
                                    <div className="d-flex justify-content-center">
                                        <span>
                                            <img src="Images/terminated-icon.svg" alt="terminated-icon" className="dashboard-style-49" />
                                        </span>
                                        <div className="d-block">
                                            <h2 className="tt-bold ps-3 font-28 mb-0 dashboard-activities-count dashboard-activities-count">
                                                {Termination}
                                            </h2>
                                            <a className="tt-bold ps-3  font-13 dashboard-link text-decoration-none">Terminated</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 position-relative">
                                <div className="row  custom-border-end">
                                    <div className="d-flex justify-content-center">
                                        <span>
                                            <img src="Images/resigned-iocn.svg" alt="resigned-iocn" className="dashboard-style-49" />
                                        </span>
                                        <div className="d-block">
                                            <h2 className="tt-bold ps-3 font-28 mb-0 dashboard-activities-count dashboard-activities-count">
                                                {Resignation}
                                            </h2>
                                            <a className="tt-bold ps-3  font-13 dashboard-link text-decoration-none">Resigned</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 position-relative">
                                <div className="row">
                                    <div className="d-flex justify-content-center">
                                        <span>
                                            <img src="Images/abscond-icon.svg" alt="abscond-icon" className="dashboard-style-49" />
                                        </span>
                                        <div className="d-block">
                                            <h2 className="tt-bold ps-3 font-28 mb-0 dashboard-activities-count dashboard-activities-count">
                                                {Abscond}
                                            </h2>
                                            <a className="tt-bold ps-3  font-13 dashboard-link text-decoration-none">Abscond</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="col-md-2 col-sm-12"> */}
                {/* <div className="card h-100 border-0 shadow-sm p-4">
                <div className="d-flex ">
                    <span><img src="Images/retentionrate-icon.svg" alt="retentionrate-icon" className="dashboard-style-49" /></span>
                    <div className="d-block">
                    <h2 className="tt-bold ps-3 mb-0 font-28 dashboard-activities-count dashboard-activities-count">70%</h2>
                    <a className="tt-bold ps-3  font-13 dashboard-link text-decoration-none" href="#">Retention Rate</a>
                    </div>
                </div>
                </div> */}
                {/* </div> */}
                <div className="col-md-12 col-sm-12">
                    <div className="card h-100 border-0 shadow-sm p-4">
                        <h1 className="tt-bold font-15 ">Insite by Domain</h1>
                        <div className="d-flex justify-content-between mb-3">
                            <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                <li className="nav-item">
                                    <button
                                        className="nav-link px-0 me-4 rounded-0 bold-text active tab-style bold-text font-13"
                                        id="dashtabExit-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#dashtabExit"
                                        type="button"
                                        role="tab"
                                        aria-controls="dashtabExit"
                                        aria-selected="true"
                                    >
                                        Exit
                                    </button>
                                </li>
                                {/* <li className="nav-item">
                        <button className="nav-link  px-0 rounded-0 bold-text tab-style bold-text font-13" id="Retention-tab" data-bs-toggle="pill" data-bs-target="#Retention" type="button" role="tab" aria-controls="Retention" aria-selected="false">Retention</button>
                    </li> */}
                            </ul>
                            <div className="d-flex legends">
                                <label className="regular-text font-11 me-4">
                                    <span className="dashboard-attrition-legrand-3 me-2" />
                                    Terminated
                                </label>
                                <label className="regular-text font-11 me-4">
                                    <span className="dashboard-salary-legrand-5 me-2" />
                                    Resigned
                                </label>
                                <label className="regular-text font-11 me-4">
                                    <span className="dashboard-salary-legrand-3 me-2" />
                                    Abscond
                                </label>
                            </div>
                        </div>
                        <div className="tab-content" id="pills-tabContent">
                            {/* dashtab Exit Tab */}
                            <div
                                className="tab-pane fade show active"
                                id="dashtab-teamcount"
                                role="tabpanel"
                                aria-labelledby="dashtab-teamcount-tab"
                                style={{ overflowX: 'auto' }}
                            >
                                <BarChart
                                    width={7500}
                                    height={300}
                                    data={insitebyDomain}>
                                    <CartesianGrid strokeDasharray="4 4" />
                                    <XAxis dataKey="domain"
                                        label={{ value: 'Practice', position: 'insideBottom', dy: 10, fontWeight: 'bold' }}
                                    />
                                    <YAxis
                                        label={{ value: 'No. of Employees', angle: -90, position: 'insideLeft', dy: 60, fontWeight: 'bold' }}

                                    />
                                    <Tooltip />
                                    <Legend content={<legends />} align="right" verticalAlign="top" legendType="circle" />
                                    <Bar
                                        dataKey="abscond"
                                        fill="#F29B10"
                                        stackId="a"
                                        barSize={20}
                                        onClick={(e) => {
                                            navigateTo('/HrOffboardingGrid', {
                                                state: {
                                                    domain: e.payload.domain,
                                                    relieving_type: 'Abscond',
                                                    start_date: filterObj.from_date,
                                                    end_date: filterObj.to_date,
                                                },
                                            });
                                        }}
                                    />

                                    <Bar
                                        dataKey="resignation"
                                        fill="#4466D8"
                                        stackId="a"
                                        barSize={20}
                                        onClick={(e) => {
                                            navigateTo('/HrOffboardingGrid', {
                                                state: {
                                                    domain: e.payload.domain,
                                                    relieving_type: 'Resignation',
                                                    start_date: filterObj.from_date,
                                                    end_date: filterObj.to_date,
                                                },
                                            });
                                        }}
                                    />
                                    <Bar
                                        dataKey="termination"
                                        fill="#D9649C"
                                        stackId="a"
                                        barSize={20}
                                        onClick={(e) => {
                                            navigateTo('/HrOffboardingGrid', {
                                                state: {
                                                    domain: e.payload.domain,
                                                    relieving_type: 'Termination',
                                                    start_date: filterObj.from_date,
                                                    end_date: filterObj.to_date,
                                                },
                                            });
                                        }}
                                    />
                                </BarChart>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="col-md-3 col-sm-12">
                <div className="card h-100 border-0 shadow-sm p-4">
                <h1 className="tt-bold font-15 mb-3 ">Exit by Gender</h1>
                <div className="text-center d-flex mt-4">

                <ResponsiveContainer width="100%" height={400}>
                    <PieChart width={400} height={400}>
                    <Pie
                        data={gender}
                        dataKey="value"
                        cx="50%"
                        cy="50%"
                        innerRadius={65}
                        outerRadius={80}
                        fill="#8884d8"
                         labelLine={false}
                        onClick={(e) => {
                            navigateTo('/HrOffboardingGrid', {
                              state: {
                                gender: e.payload.payload.name,
                              }
                            });
                          }}
                    >
                        {
                        gender.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))
                        }
                    </Pie> */}
                {/* <Tooltip /> */}
                {/* <Legend />
                    </PieChart>
                    
                </ResponsiveContainer>
                </div>
                </div>
            </div> */}
                <div class="col-md-3 col-sm-12">
                    <div class="card h-100 border-0 shadow-sm p-4">
                        <h1 class="tt-bold font-15 mb-3 ">Exit by Gender</h1>
                        <div class="text-center d-flex mt-4">
                            <div class="col-md-8">
                                {/* {/* <img src="Images/sample-pie-chart.svg" alt="dummy-image"/> */}
                                <PieChart width={200} height={200}>
                                    <Pie
                                        data={gender}
                                        dataKey="value"
                                        // cx="50%"
                                        // cy="50%"
                                        innerRadius={65}
                                        outerRadius={80}
                                        labelLine={false}
                                        onClick={(e) => {
                                            navigateTo('/HrOffboardingGrid', {
                                                state: {
                                                    gender: e.payload.payload.name,
                                                    start_date: filterObj.from_date,
                                                    end_date: filterObj.to_date,
                                                    domain: filterObj.domain
                                                },
                                            });
                                        }}
                                    >
                                        {gender.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                        ))}
                                    </Pie>
                                    {/* <Tooltip /> */}
                                    {/* <Legend /> */}
                                </PieChart>
                            </div>
                            <div class="col-md-4 align-self-center text-start">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <span class="d-flex align-items-center">
                                        <img src="Images/flag-blue.svg" alt="blue-flag" class="dashboard-custom-flagsize me-2" />
                                        <label class="semibold-text font-11">Male</label>
                                    </span>
                                    <label class="ms-2 font-18 tt-bold">{exitbyGender[1]?.male || exitbyGender[0]?.male || 'N/A'}</label>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <span class="d-flex align-items-center">
                                        <img src="Images/flag-pink.svg" alt="red-flag" class="dashboard-custom-flagsize me-2" />
                                        <label class="semibold-text font-11">Female</label>
                                    </span>
                                    <label class="ms-2 font-18 tt-bold">{exitbyGender[2]?.female || exitbyGender[0]?.female || 'N/A'}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-sm-12">
                    <div class="card h-100 border-0 shadow-sm p-4">
                        <div class="d-flex justify-content-between">
                            <h1 class="tt-bold font-15 mb-3 ">Attrition by Tenure</h1>
                            <div class="d-flex">
                                <label class="regular-text font-11 me-4">
                                    <span class="dashboard-salary-legrand-3 me-2"></span>Employees Count
                                </label>
                            </div>
                        </div>
                        <div class="col-md-12">
                            {/* <img src="Images/sample-tanure-chart.svg" alt="sample-tanure-chart" /> */}
                            <LineChart width={400} height={240} data={aggregatedData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis
                                    dataKey="tenureInterval"
                                    label={{
                                        value: 'Years of Experience', position: 'insideBottom', dy: 7,
                                        fontWeight: 'bold'
                                    }}
                                    // label={
                                    //     <text>
                                    //         <tspan dx="" dy="5" position='insideBottom'>Years of Experience</tspan>
                                    //     </text>
                                    // }
                                    interval={0}
                                    tick={{
                                        fontSize: 12
                                        //  ,fontWeight: 'bold' 
                                    }}
                                    padding={{ left: 20, right: 35 }} // Increase padding between ticks
                                />
                                <YAxis
                                    dataKey="numberOfEmployees"
                                    label={{ value: 'No. of Employees', angle: -90, position: 'insideLeft', dy: 60, fontWeight: 'bold' }}
                                    tick={{
                                        fontSize: 15
                                        // , fontWeight: 'bold'
                                    }}
                                />
                                <Tooltip />
                                <Line type="linear" dataKey="numberOfEmployees" stroke="#F29B10" connectNulls={true} />
                            </LineChart>
                            <Legend verticalAlign="bottom" legendType="circle" />
                        </div>
                    </div>
                </div>

                <div class="col-md-5 col-sm-12">
                    <div class="card h-100 border-0 shadow-sm p-4">
                        <div class="d-flex justify-content-between">
                            <h1 class="tt-bold font-15 mb-3 ">Attrition by Reason</h1>
                            <div class="d-flex">
                                <label class="regular-text font-11 me-4">
                                    <span class="dashboard-salary-legrand-3 me-2"></span>Employees Count
                                </label>
                            </div>
                        </div>
                        <div class="col-md-12 widgetYaxis"
                            style={{ height: '240px', overflowY: 'auto' }}
                        >
                            <BarChart
                                width={450}
                                height={1200} // Adjust height based on the number of bars
                                data={attritionforreason.length > 0 ? attritionforreason : [{ reason_type: filterObj.domain, employee_count: 0 }]}
                                layout="vertical" // Set layout to vertical for horizontal bar chart
                                className="db-widget-spacing cust-viewbox"
                                margin={{
                                    top: 0,
                                    right: 0,
                                    left: 80,
                                    bottom: 10,
                                }}
                                onClick={(e) => {
                                    let reasonType = e.activePayload[0].payload.reason_type;
                                    let domain = filterObj.domain;
                                    let start_date = filterObj.from_date;
                                    let end_date = filterObj.to_date;
                                    navigateTo('/HrOffboardingGrid',
                                     {
                                        state: {
                                            domain: domain,
                                            reason_type:reasonType,
                                            start_date: start_date,
                                            end_date: end_date,                                          
                                        },
                                    });
                                }}

                            >
                                <XAxis
                                    type="number"
                                    label={{
                                        value: 'No. of Employees',
                                        dx: 7,
                                        dy: 17,
                                        fontWeight: 'bold'
                                    }}
                                // tick={{ fontSize: 12, fontWeight: 'bold' }}
                                />
                                <YAxis
                                    dataKey="reason_type"
                                    type="category"
                                    label={{
                                        value: 'Reason Type',
                                        fontWeight: 'bold',
                                        angle: -90,
                                        position: 'insideLeft',
                                        dx: -45,
                                        dy: 80,
                                        fill: '#959595',
                                        color: '#959595',
                                    }}
                                    tick={{ fontSize: 12 }}
                                />
                                <Tooltip />
                                <Bar dataKey="employee_count" fill="#F29B10" barSize={20}>
                                    <LabelList dataKey="employee_count" position="right" />
                                </Bar>
                            </BarChart>
                        </div>


                    </div>
                </div>
            </div>
            {/* </div> */}
        </>
    );
}
